
import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';
import PageVideoBackground from './PageVideoBackground.js';
import AutoVideo from './AutoVideo.js';
import $ from "jquery";



function dontScroll(e) {
  e.preventDefault();
  return false;
}





export default class PageBase extends Component {

  constructor(props) {
    super(props);
    this.state = {
      scrollPhase: "top"
    }
  }


  componentDidMount() {
    //this.refs.theVideo.play();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isCurrent !== this.props.isCurrent) {
      if (this.props.isCurrent) {
        this.refs.theVideo.play();
      }
      else {
        this.refs.theVideo.pause();
      }
    }

    if (prevState.scrollPhase !== this.state.scrollPhase) {
      if (this.state.scrollPhase === "top") {
        $(".logo-main").removeClass("logo-main--hidden");
      }
      else {
        $(".logo-main").addClass("logo-main--hidden");
      }
    }
  }

  
  onWheel(e) {

    if (this.state.scrollPhase === "top" || this.state.scrollPhase === "blur") {
      e.stopPropagation();
      e.preventDefault();
    }

    if (this.state.scrollPhase === "top" && e.deltaY > 0) {
      this.scrollDown();
    }

    else if (e.deltaY < 0 && window.scrollY === 0 && this.state.scrollPhase === "bottom") {
      this.setState({
        scrollPhase: "top"
      });
    } 
  }

  onArrowClick(e) {
    if (this.state.scrollPhase === "top") {
      this.scrollDown();
    }

    else {
      $("html, body").animate({
        scrollTop: window.innerHeight
      }, 1000)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isCurrent && this.props.isCurrent) {
      this.setState({
        scrollPhase: "top"
      });
    }
  }

  scrollDown() {
    this.setState({
      scrollPhase: "blur"
    });

    setTimeout(()=>{
      this.setState({
        scrollPhase: "bottom"
      });
    }, 1000)
  }

  render() {

    let classnames = ClassNames({
      'page-base': true
    });

    classnames = classnames + ' page-base--scroll-phase-' + this.state.scrollPhase;

    return (
      <div className={classnames} onWheel={this.onWheel.bind(this)}>
        <div className="page-video-background">
          <div className="page-video-background__inner">
            <video ref="theVideo" loop={true}>
              <source src={this.props.videoSrc} type="video/mp4" />
            </video>
            <div className="page-video-background__blurb">
              {this.props.blurb}
            </div>
          </div>
        </div>
        <div className="page-info">
          <div className={"page-icon " + this.props.iconClass}></div>
          <div className="page-title">{this.props.title}</div>
        </div>
        <div className="page-down universal-down-arrow bounce" onClick={this.onArrowClick.bind(this)}></div>
        <div className="divider-1"></div>
        {
          this.state.scrollPhase !== "top" ?
            this.props.children 
          :
            null
        }
      </div>
    );
  }
}
